import type { Device } from '../../lib/types';

/** A row's Send SMS, disabled with the reason once the recipient has replied STOP to Fi's texts. */
export function sendSmsEntry(device: Device, recipient: 'Adopter' | 'Foster') {
  return {
    label: 'Send SMS',
    disabled: device.smsOptedOut,
    title: device.smsOptedOut ? `${recipient} opted out of texts` : undefined,
  };
}
